import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { Layout } from '@/components/generals/layout'

interface AuthShellProps {
    eyebrow: string
    title: string
    description: string
    children: ReactNode
}

const AuthShell: FC<AuthShellProps> = ({ eyebrow, title, description, children }): ReactNode => {
    return (
        <Layout>
            <section className='mx-auto grid min-h-[calc(100svh-4.5rem)] max-w-[1440px] lg:grid-cols-2'>
                <div className='flex items-center px-5 py-14 sm:px-10 lg:px-16'>
                    <div className='mx-auto w-full max-w-md'>
                        <p className='eyebrow'>{eyebrow}</p>
                        <h1 className='mt-3 font-display text-4xl leading-tight sm:text-5xl'>{title}</h1>
                        <p className='mt-3 text-sm leading-relaxed text-muted-foreground'>{description}</p>

                        <div className='mt-8'>{children}</div>
                    </div>
                </div>

                <div className='relative hidden overflow-hidden bg-ink lg:block'>
                    <Image
                        src='/images/fluted-partition.jpg'
                        alt='Zwart stalen kader met ribbelglas in een licht interieur'
                        fill
                        sizes='50vw'
                        className='object-cover opacity-85'
                        priority
                    />

                    <div className='absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent' />

                    <blockquote className='absolute inset-x-12 bottom-12 text-ink-foreground'>
                        <p className='font-display text-3xl leading-snug italic'>
                            &ldquo;Licht, ruimte en een deur die elke dag weer klopt. Dat is waar we het voor doen.&rdquo;
                        </p>
                        <footer className='mt-4 text-xs tracking-[0.2em] text-brass uppercase'>De werkplaats van ArtDoors</footer>
                    </blockquote>
                </div>
            </section>
        </Layout>
    )
}

export default AuthShell
